import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import nccLogo from "images/logo/ncc-logo.png";
import nccBuildingImg from "images/GroupCompany/ncc-building.jpeg";

// Container with Background Image and Overlay
const BackgroundContainer = styled.div`
  ${tw`relative flex items-center justify-center h-screen text-center px-4`}
  background-image: url(${nccBuildingImg});
  background-size: cover;
  background-position: center;

  &:before {
    content: "";
    ${tw`absolute inset-0 bg-black opacity-50`}
  }
`;

// Centered Content Wrapper
const Content = tw.div`relative z-10 flex flex-col items-center justify-center w-full h-full`;

// Logo at the top
const Logo = styled.img`
  ${tw`w-32 mb-8`};
`;

// Title and Subtitle
const Title = tw.h1`text-5xl sm:text-6xl font-bold text-white mb-4`;
const SubTitle = tw.p`text-lg sm:text-xl text-gray-300 mb-8`;

// Styled Button
const PrimaryButton = styled(PrimaryButtonBase)`
  ${tw`text-sm px-8 py-4 rounded-full bg-ncc text-white hover:bg-blue-700`}
`;

export default () => {
  return (
    <BackgroundContainer>
      <Content>
        <Logo src={nccLogo} alt="Nippon Cloud Logo" />
        <Title>404 - Page Not Found</Title>
        <SubTitle>Sorry, the page you’re looking for doesn’t exist.</SubTitle>
        <PrimaryButton as="a" href="/">
          Back to Home
        </PrimaryButton>
      </Content>
    </BackgroundContainer>
  );
};
